import React, { useEffect, useState, useCallback } from "react";

import "./App.css";
import "./resources/css/Sidebar.css";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import io from "socket.io-client";
import Login from "./components/Login";
import MainNotify from "./components/layout/MainNotify";
import { EnquiryForm } from "./components/enquiryForm";
// import Home from "./components/Home/Home";
// import Dashboard from "./components/Home/Dashboard";
// import ProjectDashboard from "./components/Dashboard/ProjectDashboard";
// import Calendar from "./components/Home/Calendar";
// import { ReportList, ReportView } from "./components/Report";
// import { UserProfileEdit } from "./components/UserProfile";
// import { BackupList } from "./components/Backup";

// 

// import {
//   LeadEdit,
//   LeadList,
//   LeadView,
//   LeadEditByModel, FollowUpLeadsToday
// } from "./components/Lead";
// import { ProjectEdit, ProjectList, ProjectView } from "./components/Project";
// import { ProductEdit, ProductList, ProductView } from "./components/Product";
// import { AccountEdit, AccountList, AccountView } from "./components/Account";
// import { ContactEdit, ContactList, ContactView } from "./components/Contact";
// import { RepairTicketEdit, RepairTicketList, RepairTicketView } from "./components/RepairTicket";
// import { UserEdit, UserList, UserView } from "./components/UserManagement";
// import { ArchiveList, ArchiveView } from "./components/Archive";

import * as constants from "./constants/CONSTANT";
import PubSub from "pubsub-js";
import { Toast, ToastContainer } from "react-bootstrap";

/*********************
 * CP Code
 *******************/
//eslint-disable-next-line
// import { PATHS } from "./constants/WebRouting";

//eslint-disable-next-line
// import NoAccess from "./components/common/NoAccess";

import { getUserDetails } from "../src/utils/helper";
import { ROUTES } from "./constants/webRouting";

// -------------------- Components Imports Starts Here -------------------------------------

import { ContactEdit, ContactList, ContactView } from "./components/contact";
import { AccountEdit, AccountList, AccountView } from "./components/account";
import { LeadEdit, LeadList, LeadView } from "./components/lead";
import Home from "./components/home/Home";
import { UserList, UserView, UserEdit } from "./components/userManagement";
import { BackupList } from "./components/backup";
import UserTracking from "./components/siteVisit/UserTracking";
import { OfferEdit, OfferList, OfferView } from "./components/offer";
import {
  ProductEdit,
  ProductList,
  ProductView
} from "./components/product";
import { OrderEdit, OrderList, OrderView } from "./components/order";
import { OrderAmcEdit, OrderAmcList, OrderAmcView } from "./components/orderAmc";
import { ReportList, ReportView } from "./components/report";
import { WarrantyList, WarrantyEdit, WarrantyView } from "./components/warranty"
import { SiteVisitReportList, SiteVisitReportView, SiteVisitReportEdit } from "./components/siteVisitReport";     // Added by Imran Khan on 18-March-2026
import { HandoverEdit, HandoverList, HandoverView } from "./components/handover";
import { UserProfileEdit } from "./components/userProfile";
import SettingsPage from "./components/settings";
import PricingMasterList from "./components/pricingMaster/PricingMasterList";
import MarginMasterList from "./components/marginMaster/MarginMasterList";




// ----------------------------- End Here Component Imports ----------------------------------

// import Header from "./components/layout/common/Header";
// import WhiteObjectApi from "../../../api/WhiteObjectApi";

/*********************
 * CP Code
 *******************/
const ENDPOINT = constants.SOCKET_BASE_URL;

function App() {
  const [showToastContainer, setShowToastContainer] = useState(false);
  const [title, setTitle] = useState("Confirmation");
  const [message, setMessage] = useState("");
  const [connectedSocket, setConnectedSocket] = useState(null);
  const [variant, setVariant] = useState("");
  //eslint-disable-next-line
  const [userInfo, setUserInfo] = useState({});
  //eslint-disable-next-line
  const [permissions, setPermissions] = useState();

  // FIX 1: useCallback se stable reference — duplicate subscription nahi hogi
  const mySubscriber = useCallback((msg, data) => {
    switch (msg) {
      case "RECORD_SAVED_TOAST":
        setTitle(data.title);
        setMessage(data.message);
        setShowToastContainer(true);
        setVariant("success");
        break;
      case "RECORD_ERROR_TOAST":
        setTitle(data.title);
        setMessage(data.message);
        setShowToastContainer(true);
        setVariant("danger");
        break;
      default:
        break;
    }
  }, []);

  useEffect(() => {
    // FIX 2: token save karo aur cleanup mein unsubscribe karo
    const token1 = PubSub.subscribe("RECORD_SAVED_TOAST", mySubscriber);
    const token2 = PubSub.subscribe("RECORD_ERROR_TOAST", mySubscriber);

    try {
      if (localStorage.getItem("token")) {
        let user = getUserDetails();
        setUserInfo(user);

        var perm = user.permissions
          .map(function (obj) {
            return obj.name;
          })
          .join(";");
        setPermissions(perm);

        //socket
        console.log('ENDPOINT', ENDPOINT);

      }

    } catch (error) {
      console.log(error);
    }

    // FIX 3: cleanup — unmount pe unsubscribe, duplicate band
    return () => {
      PubSub.unsubscribe(token1);
      PubSub.unsubscribe(token2);
    };
  }, [mySubscriber]);

  useEffect(()=>{
    let socket = io(ENDPOINT, {     // note changed URL here
      path: '/ibs/socket.io',
      transports: ['websocket'],
    });
    console.log('socket==',);
    socket.on("connect_error", (err) => {
      console.log(`connect_error due to`, err);
    });

    socket.on("connect", () => {
      let user = getUserDetails();
      if (user?.id) {
        socket.emit("setup", user);
      }
      setConnectedSocket(socket);
    });
  
    socket.on('disconnect', (reason) => {
    });
    socket.on('greetings', (data) => {
      window.dispatchEvent(new CustomEvent('new-notification', { detail: data }));
    });

    return () => {
      socket.disconnect();
    };
  }, [userInfo]);

  return (
    <>
      <ToastContainer className="p-3" position="top-center">
        <Toast
          show={showToastContainer}
          onClose={() => setShowToastContainer(false)}
          delay={3000}
          bg={variant}
          className="text-white"
          autohide
        >
          {variant === "success" ? (
            <div
              className="p-1 m-1"
              style={{ backgroundColor: "#198754", color: "white" }}
            >
              <i className="fa-regular fa-circle-check text-white mx-2"></i>
              <strong className="me-auto">{title}</strong>
              <i
                className="fa-solid fa-xmark text-white float-right"
                style={{ float: "right" }}
                role="button"
                onClick={() => setShowToastContainer(false)}
              ></i>
            </div>
          ) : (
            <div
              className="p-1 m-1"
              style={{ backgroundColor: "#DC3545", color: "white" }}
            >
              <i className="fa-regular fa-circle-check text-white mx-2"></i>
              <strong className="me-auto">{title}</strong>
              <i
                className="fa-solid fa-xmark text-white float-right"
                style={{ float: "right" }}
                role="button"
                onClick={() => setShowToastContainer(false)}
              ></i>
            </div>
          )}

          <Toast.Body>
            {message instanceof Array ? (
              message.map((item) => {
                return <span>{item.msg}</span>;
              })
            ) : (
              <span>{message}</span>
            )}
          </Toast.Body>
        </Toast>
      </ToastContainer>

      <Router>
        <Routes>
          {/* Login Route */}
          <Route path={ROUTES.LOGIN} exact element={<Login />} />

          {/* Main Route */}
          <Route path={ROUTES.HOME} element={<MainNotify socket={connectedSocket} />}>

            {/* Home Route */}
            <Route index exact element={<Home />} />

            {/* Account Route */}

            <Route path={ROUTES.ACCOUNT.CREATE} exact element={<AccountEdit />} />
            <Route path={ROUTES.ACCOUNT.LIST} exact element={<AccountList />} />
            <Route path={ROUTES.ACCOUNT.VIEW} exact element={<AccountView />} />
            <Route path={ROUTES.ACCOUNT.EDIT} exact element={<AccountEdit />} />

            {/* Contact Route */}

            <Route path={ROUTES.CONTACT.CREATE} exact element={<ContactEdit />} />
            <Route path={ROUTES.CONTACT.LIST} exact element={<ContactList />} />
            <Route path={ROUTES.CONTACT.VIEW} exact element={<ContactView />} />
            <Route path={ROUTES.CONTACT.EDIT} exact element={<ContactEdit />} />

            {/* Lead Route */}
            <Route path={ROUTES.LEAD.CREATE} exact element={<LeadEdit />} />
            <Route path={ROUTES.LEAD.LIST} exact element={<LeadList />} />
            <Route path={ROUTES.LEAD.VIEW} exact element={<LeadView />} />
            <Route path={ROUTES.LEAD.EDIT} exact element={<LeadEdit />} />

            {/* User Route */}
            <Route path={ROUTES.USER.CREATE} exact element={<UserEdit />} />
            <Route path={ROUTES.USER.LIST} exact element={<UserList />} />
            <Route path={ROUTES.USER.VIEW} exact element={<UserView />} />
            <Route path={ROUTES.USER.EDIT} exact element={<UserEdit />} />

            {/* UserTracking Route */}
            <Route path={ROUTES.USER_TRACKING} exact element={<UserTracking />} />

            {/* Offer Route */}
            <Route path={ROUTES.OFFER.CREATE} exact element={<OfferEdit />} />
            <Route path={ROUTES.OFFER.LIST} exact element={<OfferList />} />
            <Route path={ROUTES.OFFER.VIEW} exact element={<OfferView />} />
            <Route path={ROUTES.OFFER.EDIT} exact element={<OfferEdit />} />

            {/* Order Route */}
            <Route path={ROUTES.ORDER.CREATE} exact element={<OrderEdit />} />
            <Route path={ROUTES.ORDER.LIST} exact element={<OrderList />} />
            <Route path={ROUTES.ORDER.VIEW} exact element={<OrderView />} />
            <Route path={ROUTES.ORDER.EDIT} exact element={<OrderEdit />} />

            {/* Handover Route */}
            <Route path={ROUTES.HANDOVER.LIST} exact element={<HandoverList />} />
            <Route path={ROUTES.HANDOVER.CREATE} exact element={<HandoverEdit />} />
            <Route path={ROUTES.HANDOVER.EDIT} exact element={<HandoverEdit />} />
            <Route path={ROUTES.HANDOVER.VIEW} exact element={<HandoverView/>} />

            {/* Warranty Route */}

            <Route path={ROUTES.WARRANTY.LIST} exact element={<WarrantyList />} />
            <Route path={ROUTES.WARRANTY.CREATE} exact element={<WarrantyEdit />} />
            <Route path={ROUTES.WARRANTY.VIEW} exact element={<WarrantyView />} />
            <Route path={ROUTES.WARRANTY.EDIT} exact element={<WarrantyEdit />} />

            {/* Added by Imran Khan Site Visit Report Route */}
            <Route path={ROUTES.SITE_VISIT_REPORT.LIST} exact element={<SiteVisitReportList />} />
            <Route path={ROUTES.SITE_VISIT_REPORT.CREATE} exact element={<SiteVisitReportEdit />} />
            <Route path={ROUTES.SITE_VISIT_REPORT.VIEW} exact element={<SiteVisitReportView />} />
            <Route path={ROUTES.SITE_VISIT_REPORT.EDIT} exact element={<SiteVisitReportEdit />} />

            {/* Order AMC Route */}
            <Route path={ROUTES.ORDER_AMC.CREATE} exact element={<OrderAmcEdit />} />
            <Route path={ROUTES.ORDER_AMC.LIST} exact element={<OrderAmcList />} />
            <Route path={ROUTES.ORDER_AMC.VIEW} exact element={<OrderAmcView />} />
            <Route path={ROUTES.ORDER_AMC.EDIT} exact element={<OrderAmcEdit />} />

            {/* Product Route */}
            <Route path={ROUTES.PRODUCT.CREATE} exact element={<ProductEdit />} />
            <Route path={ROUTES.PRODUCT.LIST} exact element={<ProductList />} />
            <Route path={ROUTES.PRODUCT.VIEW} exact element={<ProductView />} />
            <Route path={ROUTES.PRODUCT.EDIT} exact element={<ProductEdit />} />

            {/* Report Route */}
            <Route path={ROUTES.REPORT.LIST} exact element={<ReportList />} />
            <Route path={ROUTES.REPORT.VIEW} exact element={<ReportView />} />

            {/* Dashboard Route
            <Route path={ROUTES.DASHBOARD} exact element={<>Dashboard</>} /> */}

            {/* Backup Route */}
            <Route path={ROUTES.BACKUP} exact element={<BackupList />} />

            {/* Profile Route */}
            <Route path={ROUTES.PROFILE} exact element={<UserProfileEdit/>} />

            {/* Settings Route */}
            <Route path={ROUTES.SETTINGS} exact element={<SettingsPage />} />

            {/* Pricing Master Route - SUPER_ADMIN only */}
            <Route path={ROUTES.PRICING_MASTER.LIST} exact element={<PricingMasterList />} />
            {/* Margin Master Route - SUPER_ADMIN only */}
            <Route path={ROUTES.MARGIN_MASTER.LIST} exact element={<MarginMasterList />} />

            {/* Page not found Route */}
            <Route path={"*"} exact element={<>Not Found</>} />

          </Route>

          <Route path={ROUTES.ENQUIRY_FORM} exact element={<EnquiryForm />} />

        </Routes>


      </Router>
    </>
  );
}

export default App;
